import { render, staticRenderFns } from "./CuentaContacto.vue?vue&type=template&id=0538d070&"
import script from "./CuentaContacto.vue?vue&type=script&lang=js&"
export * from "./CuentaContacto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports